import { defineComponent as _defineComponent } from 'vue'
import {
    setMelcoCredentials,
    setOpenAiApiKey,
    setRemoveBgApiKey,
    setVanceAiApiKey,
    setCutoutProApiKey,
    setSpotifyCredentials,
    deleteCanvaCredentials,
    setGoogleGeminiApiKey,
    setOpenRouterApiKey
} from '@/api/user';
import { CustomilyUser } from '@/typings/user';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import ApiKeyInput from '@/components/ApiKeyInput/ApiKeyInput.vue';
import store from '@/store';
import { computed, onBeforeMount, reactive, ref } from 'vue';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'Integrations',
  emits: ["user-updated"],
  setup(__props, { emit }: { emit: ({
    (event: 'user-updated'): void;
}), expose: any, slots: any, attrs: any }) {



const isImageEffectsEnabled = process.env.VUE_APP_IMAGE_EFFECTS_ENABLED === 'true';

const removeBgApiKey = ref('');
const melcoUsername = ref('');
const melcoApiKey = ref('');
const cutoutProApiKey = ref('');
const cutoutProError = ref('');
const googleGeminiError = ref('');
const openRouterError = ref('');

const vanceAiApiKey = ref('');
const openAiApiKey = ref('');
const openAiApiKeyState = ref<boolean | null>(null);
const openAiError = ref('');

const spotifyClientID = ref('');
const spotifyClientSecret = ref('');

const googleGeminiApiKey = ref('');
const openRouterApiKey = ref('');

const savingState = reactive({
    vanceAi: false,
    removeBg: false,
    melcoCredentials: false,
    openAi: false,
    cutoutPro: false,
    spotifyCredentials: false,
    canvaCredentials: false,
    googleGemini: false,
    openRouter: false
});

const user = computed((): CustomilyUser => store.state.user!);
const openAiVerified = computed(() => {
    if (!openAiApiKey.value) {
        return true;
    }
    return (
        typeof openAiApiKey.value === 'string' && openAiApiKey.value.length > 0 && openAiApiKey.value.startsWith('sk')
    );
});

const modifiedRemoveBgApiKey = computed(() => user.value.RemoveBgAPIKey != removeBgApiKey.value);
const modifiedCutoutProApiKey = computed(() => user.value.CutoutproAPIKey != cutoutProApiKey.value);

onBeforeMount(() => {
    removeBgApiKey.value = user.value.RemoveBgAPIKey || '';
    vanceAiApiKey.value = user.value.VanceAiAPIKey || '';
    openAiApiKey.value = user.value.OpenAiAPIKey || '';
    melcoUsername.value = user.value.MelcoUsername || '';
    melcoApiKey.value = user.value.MelcoApiKey || '';
    cutoutProApiKey.value = user.value.CutoutproAPIKey || '';
    spotifyClientID.value = user.value.SpotifyClientID || '';
    spotifyClientSecret.value = user.value.SpotifyClientSecret || '';
    googleGeminiApiKey.value = user.value.GoogleGeminiAPIKey || '';
    openRouterApiKey.value = user.value.OpenRouterAPIKey || '';
});

const onRemoveBgSubmit = async () => {
    try {
        savingState.removeBg = true;
        await setRemoveBgApiKey(removeBgApiKey.value);
    } finally {
        savingState.removeBg = false;
        emit('user-updated');
    }
};

const onVanceAiSubmit = async () => {
    savingState.vanceAi = true;
    await setVanceAiApiKey(vanceAiApiKey.value);
    savingState.vanceAi = false;
    emit('user-updated');
};

const onOpenAiSubmit = async () => {
    savingState.openAi = true;
    try {
        await setOpenAiApiKey(openAiApiKey.value);
        openAiApiKeyState.value = true;
        openAiError.value = '';
        emit('user-updated');
    } catch (error) {
        openAiApiKeyState.value = false;
        openAiError.value = (error as Error).message;
    } finally {
        savingState.openAi = false;
    }
};

const onMelcoCredentialsSubmit = async () => {
    try {
        savingState.melcoCredentials = true;
        await setMelcoCredentials(melcoUsername.value, melcoApiKey.value);
    } finally {
        savingState.melcoCredentials = false;
        emit('user-updated');
    }
};

const onCutoutProSubmit = async () => {
    try {
        savingState.cutoutPro = true;
        cutoutProError.value = '';
        await setCutoutProApiKey(cutoutProApiKey.value);
        emit('user-updated');
    } catch (error) {
        cutoutProError.value = (error as AxiosError).response?.data?.Message;
    } finally {
        savingState.cutoutPro = false;
    }
};

const onSpotifyCredentialsSubmit = async () => {
    try {
        savingState.spotifyCredentials = true;
        await setSpotifyCredentials(spotifyClientID.value, spotifyClientSecret.value);
    } finally {
        savingState.spotifyCredentials = false;
        emit('user-updated');
    }
};

const diconnectUserFromCanva = async () => {
    try {
        savingState.canvaCredentials = true;
        await deleteCanvaCredentials();
    } finally {
        savingState.canvaCredentials = false;
        emit('user-updated');
    }
};

const onGoogleGeminiApiSubmit = async () => {
    try {
        savingState.googleGemini = true;
        googleGeminiError.value = '';
        await setGoogleGeminiApiKey(googleGeminiApiKey.value);
    } catch (error) {
        googleGeminiError.value = (error as Error).message;
    } finally {
        savingState.googleGemini = false;
        emit('user-updated');
    }
};

const onOpenRouterApiSubmit = async () => {
    try {
        savingState.openRouter = true;
        openRouterError.value = '';
        await setOpenRouterApiKey(openRouterApiKey.value);
    } catch (error) {
        openRouterError.value = (error as Error).message;
    } finally {
        savingState.openRouter = false;
        emit('user-updated');
    }
};

return { __sfc: true,emit, isImageEffectsEnabled, removeBgApiKey, melcoUsername, melcoApiKey, cutoutProApiKey, cutoutProError, googleGeminiError, openRouterError, vanceAiApiKey, openAiApiKey, openAiApiKeyState, openAiError, spotifyClientID, spotifyClientSecret, googleGeminiApiKey, openRouterApiKey, savingState, user, openAiVerified, modifiedRemoveBgApiKey, modifiedCutoutProApiKey, onRemoveBgSubmit, onVanceAiSubmit, onOpenAiSubmit, onMelcoCredentialsSubmit, onCutoutProSubmit, onSpotifyCredentialsSubmit, diconnectUserFromCanva, onGoogleGeminiApiSubmit, onOpenRouterApiSubmit, LoaderBtn, ApiKeyInput }
}

})